import { baseApi } from "@/lib/axios";
import { FREE_GAS_API } from "./index";

export function getFreeGas(data: { receiverAddr: string; chainId: string }) {
  return baseApi<string>({
    url: FREE_GAS_API.urlFreeGas,
    method: "POST",
    data: {
      receiverAddr: data.receiverAddr,
      chainId: data.chainId,
    },
  });
}
